<app-header></app-header>

<div class="mfa-page">
  <div class="mfa-card">
    <div class="mfa-card-banner">
      <div class="brand">
        <span class="vimacc">vima<span class="vimacc-cc">cc</span></span
        ><span class="reg">®</span>
        <div class="vimacc-ol">License Portal</div>
      </div>
    </div>

    <div class="mfa-card-body">
      <h2 class="mfa-title">{{ "mfa.setupTitle" | translate }}</h2>
      <app-mfa-enroll
        *ngIf="setupToken"
        [setupToken]="setupToken"
        (done)="onDone()"
      ></app-mfa-enroll>
    </div>
  </div>
</div>

<app-footer></app-footer>
